export const triggerEvent = (strEvent, data) => {
  const event = new CustomEvent(strEvent, {
    detail: data
  })
  window.dispatchEvent(event)
}

export const listenForEvent = (strEvent, func) => {
  const listener = e => func(e.detail)
  window.addEventListener(strEvent, listener)
  return () => window.removeEventListener(strEvent, listener)
}